import { render, staticRenderFns } from "./Jsgl.vue?vue&type=template&id=37a24f86&scoped=true&"
import script from "./Jsgl.vue?vue&type=script&lang=js&"
export * from "./Jsgl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a24f86",
  null
  
)

export default component.exports